export default __webpack_public_path__ + "static/media/albert_empty_data.b3c5988d.svg";